import _ from 'lodash'

import serverProps from '../public/js/transfer/utils/serverProps'

import LINKS from './links.json'

const LIVE_HOST_NAME = _.get(serverProps, 'liveHostName')

export default {
  successHeader: ["You've sent", 'to'],
  successShopsHeader: ['You paid'],
  giftSuccessHeader: ["You've sent a gift of", 'to'],
  youSent: 'You sent:',
  youPaid: 'You paid:',
  fee: 'Fee:',
  recipientName: 'will get:',
  reactConversionRate: 'Conversion rate:',
  fundsAvailabilityDate: 'Funds Availability Date',
  thirdPartyFees: 'Recipient may receive less due to foreign taxes.',
  SPECIAL_LIMITS:
    'The recipient has a lifetime limit to send, spend or withdraw. Upon reaching this limit, the recipient must take certain actions to lift the limit.',
  NO_SPECIAL_LIMITS_VERIFIED_PPZ:
    'Note: The recipient will be able to withdraw the money on this date.',
  NO_SPECIAL_LIMITS_VERIFIED_NO_PPZ_SEND_ENABLED:
    'Note: The recipient can send or spend the full amount on this date. If the recipient wishes to withdraw money, limits may apply.',
  NO_SPECIAL_LIMITS_UNVERIFIED_SEND_ENABLED:
    'Note: Currently, there are limits to how much the recipient can send, spend or withdraw. To access the full amount on this date, the recipient can link a bank or card.',
  NO_SPECIAL_LIMITS_NO_SEND_ENABLED:
    'Sorry, this information currently is unavailable.',
  UNAVAILABLE: 'Sorry, this information currently is unavailable.',
  UNILATERAL:
    'Note: To access the funds, recipient must open a PayPal account and link and confirm a bank or a card.',
  RECIPIENT_HAS_RESERVES_OR_RESTRICTIONS:
    "The payment will be credited to the recipient's PayPal account. The recipient will be able to access the funds according to the terms of their PayPal User agreement. This should Not impact the shipping date or any agreement you have with the seller.",
  needToCancel: 'Need to cancel?',
  needToCancelContent:
    "You have the right to cancel for a full refund unless your designated recipient has already received the payment. However, since most PayPal payments are received within seconds, you may not be able to cancel your payment for a full refund once the payment is made. To determine whether your payment is eligible for cancellation, log in to <a href='/myaccount/home'>PayPal.com</a>, select the transaction in your transaction details, and select Cancel, or call PayPal Customer Service at <a href='tel:1-888-221-1161' style='white-space: nowrap;'>1-888-221-1161</a>.",
  aboutDisputes: 'About disputes',
  aboutDisputesContent:
    "<p>If this payment is for an item you purchased but haven’t received, or it’s not as described, your purchase may be covered under PayPal’s purchase protection.  In those cases, you can file a dispute in the Resolution Center within 180 days of payment.  Just log in to PayPal at <a href='/'>PayPal.com</a> and go to the Resolution Center or call Customer Service at <a href='tel:1-888-221-1161' style='white-space: nowrap;'>1-888-221-1161</a>.</p><p>If you have a different problem with this payment sent to someone outside the United States – for example, the payment was never received, or it was processed for the wrong amount – you have up to 180 days to dispute it. To file a dispute for this payment or to request a written explanation of your rights, go to the Resolution Center or call Customer Service.</p><p>If you don't recognize this payment or want to report it as unauthorized, you should contact the Resolution Center at <a href='/'>PayPal.com</a> or call Customer Service.</p>",
  'rtr.aboutDisputesPara.one':
    "<p>If this payment is for an item you purchased but haven’t received, or it’s not as described, your purchase may be covered under PayPal, Inc.’s purchase protection. In those cases, you can file a dispute in the Resolution Center within 180 days of payment. Just log in to your PayPal account at <a href='/'>www.paypal.com</a> and go to the Resolution Center or call Customer Service at <a href='tel:1-888-221-1161' style='white-space: nowrap;'>1-888-221-1161</a>.</p>",
  'rtr.aboutDisputesPara.two':
    "<p>You have a right to dispute errors in your transaction. If you think there is an error, such as a payment that was never received or that was processed for the wrong amount, contact Customer Service at <a href='tel:1-888-221-1161' style='white-space: nowrap;'>1-888-221-1161</a> within 180 days. You can also contact us for a written explanation of your rights.</p>",
  'rtr.aboutDisputesPara.three':
    "<p>If you don’t recognize this payment or want to report it as unauthorized, you should contact the Resolution Center at <a href='/'>PayPal.com</a> or call Customer Service at the number above.</p>",
  agencyInfo:
    'For questions or complaints about PayPal, you can contact these agencies:',
  consumerFinance:
    "<p class='ppvx_text--md ppvx_text--regular'>Consumer Financial Protection Bureau</p><p><a href='tel:(855)411-2372' style='white-space: nowrap;'>(855)411-2372</a> or <br /><a href='tel:(855)729-2372' style='white-space: nowrap;'>(855)729-2372 (TTY/TDD)</a></p><p><a href='http://www.consumerfinance.gov/' target='_blank'>www.consumerfinance.gov</a></p>",
  optionsNewCreditCardExchangeRate:
    'Your card issuer will determine the currency conversion rate and what fees they may charge. Check your statement for the final amount.',
  infoFee: 'This rate includes a currency conversion spread.',
  infoLookForFee:
    'This rate includes a currency conversion spread. The amount you’ll pay may change as we lock in your rate, so check your final amount and fee details before you send.',
  infoBetterFee:
    'Good news! We found a better rate and applied it here. This rate includes a currency conversion spread.',
  infoSimpleFeeDisclaimer: 'This rate includes a currency conversion spread.',
  instructionsNewForeignExchangeDisclaimer:
    'PayPal makes money through this exchange rate when we convert your currency.',
  infoNewFeeDisclaimer:
    'In addition to the fee listed above, PayPal makes money through this exchange rate when we convert your currency.',
  'label.youreDonatingRecurringWith': 'Donating monthly from',
  'label.yourePayingWith': "You're sending with",
  'label.youreDonatingWith': 'Donating from',
  'label.sendText': "You'll send",
  'label.subtotalText': 'Subtotal',
  'copy.feeText': 'PayPal fee',
  'copy.customerFeeText': 'Fee',
  'copy.free': 'No Fee for you',
  'rtr.youllDonate': "You'll donate",
  'rtr.total': 'Total',
  'label.inSeconds': 'In seconds',
  'label.paymentDelivery': 'Payment delivery',
  'rtr.youllPay': "You'll pay",
  'rtr.shipping': 'Shipping',
  'rtr.recipientGets': 'will get',
  'content.currencyConversion': 'Conversion rate:',
  'currencyConversion.paypalExchangeRate': 'Exchange rate:',
  'currencyConversion.cardExchangeRate': 'Exchange rate: Unknown',
  'rtr.thirdPartyFees': 'Recipient may receive less due to foreign taxes.',
  'fundingType.paypalBalance': 'PayPal Balance',
  'fundingType.paypalBalanceCfpb': 'Balance',
  'fundingType.creditCard': 'Credit Card',
  'fundingType.paypalCredit': 'PayPal Credit',
  'fundingType.ppCreditOfferNotApplicable':
    'Not eligible for special financing offer',
  'fundingType.ppCreditOfferEligible': `No Interest if paid in full in 6 months. <a href='${LIVE_HOST_NAME}${LINKS.US.PAYPAL_CREDIT_SEE_TERMS_LINK}' target='_blank'>See terms</a>`,
  'fundingType.ppCreditOfferNotEligible': `Pay over time for this purchase. <a href='${LIVE_HOST_NAME}${LINKS.US.PAYPAL_CREDIT_SEE_TERMS_LINK}' target='_blank'>See terms</a>`,
  'fundingType.smartConnect': 'PayPal Smart Connect',
  'fundingType.smartConnectWithBalance':
    'PayPal Smart Connect (with PP balance)',
  'fundingType.checking': 'Checking',
  'fundingType.credit': 'Credit',
  'fundingType.debit': 'Debit',
  'fundingType.savings': 'Savings',
  'fundingType.visa': 'Visa',
  'fundingType.mastercard': 'Mastercard',
  'fundingType.amex': 'American Express',
  'fundingType.discover': 'Discover',
  'fundingType.china_union_pay': 'UnionPay',
  'fundingType.dualcardplus': 'PayPal MasterCard&#174;',
  'fundingType.dualcardpluswithbalance':
    'PayPal MasterCard&#174; (with PP balance)',
  'fundingType.dualcardebay': 'eBay MasterCard&#174;',
  'fundingType.dualcardebaywithbalance':
    'eBay MasterCard&#174; (with PP balance)',
  'fundingType.paypal': 'PayPal',
  'fundingType.maestro': 'Maestro',
  'fundingType.backup': 'Backup:',
  'label.cvvText': 'Please enter the 3-4 digits security code on your card.',
  'label.cvvHelperText':
    'The CVV is the 3-digit number on the back of your card.',
  'copy.echek': 'Money should be there around.',
  'copy.iach': 'The money will be sent right away.',
  'copy.feeIsIncluded': 'Charge includes fee',
  'currency.conversion.paypal': 'Convert currency with PayPal',
  'currency.conversion.cardIssuer': 'Convert currency with card issuer',
  'currency.conversion.card': 'Convert currency with card',
  'copy.sellerFee': 'Seller Fee',
  'copy.sellerWillGet': 'Seller will get',
  'sendDetail.yourTotal': 'Your total',
  note: 'Add a note',
  'unified.paymentTypeToggle.send': 'Sending to a friend',
  'unified.paymentTypeToggle.buy': 'Paying for an item or service',
  'shield.paymentTypeTogglePurchaseProtection': 'More on Purchase Protection',
  'unified.paymentTypeToggleBuyHelperText':
    'Get a full refund if an eligible item gets lost or damaged. Seller pays a small fee.',
  'unified.paymentTypeToggleSendHelperText':
    'Purchase Protection doesn’t apply for this payment.',
  'unified.paymentTypeToggle.personal': 'Personal',
  'unified.paymentTypeToggle.protection': 'Purchase',
  'label.yourShippingAddress': 'Your shipping address',
  'label.yourMailingAddress': 'Your mailing address',
  'label.addNewShippingAddress': '+ Add a new shipping address',
  'label.addNewMailingAddress': '+ Add a new mailing address',
  'label.notifyUserText': "We'll notify them with a text on your behalf",
  'recipientInfo.nameLabel': "Recipient's name",
  'recipientInfo.defaultCountry': "Recipient's country or region of residence",
  'shield.explanation': 'Eligible purchases are covered by ',
  'shield.paypalPurchaseProtection': 'PayPal Purchase Protection',
  'unified.purchaseProtectionLink': '/webapps/mpp/paypal-safety-and-security',
  'description.userAgreement': [
    'For more information please read our',
    'user agreement',
  ],
  'description.paymentMethods':
    "View <a href='/webapps/mpp/popup/about-payment-methods' target='_blank'>PayPal Policies</a> and your payment method rights.",
  'description.poolsTermsAndConditions':
    "This is a personal contribution with the same rights as a friends and family payment. For more details, please read our <a href='/pools/terms' target='_blank'>Money Pools terms and conditions</a>.",
  'disclosure.stateMandatedWarning':
    'Make sure you know who you’re sending to. If you’re scammed, you won’t be able to get your money back.',
}
